import { createSlice } from '@reduxjs/toolkit';
import environmentTypesActions from './actions';
import { EnvironmentTypesState } from './types';

const initialState: EnvironmentTypesState = {
  environmentTypes: [],
  environmentTypesError: null,
  environmentTypesLoading: false,
  environmentTypesIsEmpty: false,
};

export const environmentTypesSlice = createSlice({
  initialState,
  name: 'environmentTypes',
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(environmentTypesActions.getEnvironmentTypes.pending, (state) => {
      state.environmentTypesLoading = true;
    });

    builder.addCase(
      environmentTypesActions.getEnvironmentTypes.fulfilled,
      (state, { payload: { environmentTypes } }) => {
        state.environmentTypesError = null;
        state.environmentTypesLoading = false;
        state.environmentTypes = environmentTypes;
        state.environmentTypesIsEmpty = !!!environmentTypes.length;
      }
    );

    builder.addCase(environmentTypesActions.getEnvironmentTypes.rejected, (state, { error }) => {
      state.environmentTypesLoading = false;
      state.environmentTypesError = error;
    });
  },
});

export default environmentTypesSlice.reducer;
